import { createAction, props } from '@ngrx/store';
import { Lead } from '@shared/models/lead';

export const updateLead = createAction('[Leads] Update Lead', props<{ lead: Partial<Lead> }>());

export const updateLeadSuccess = createAction('[Leads] Update Lead Success', props<{ lead: Lead }>());

export const updateLeadFailure = createAction('[Leads] Update Lead Failure', props<{ error: any }>());
